module.exports = __webpack_public_path__ + "img/page11.0d98c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax/page11.png
// module id = +eXE
// module chunks = 0